import { useContext, FC, PropsWithChildren, useState, createContext } from 'react';
import { MovableInkCampaign } from '../types';
import { useMovableInkCampaignsMutation } from '../hooks/useMovableInkCampaignsMutation';
import noop from 'utils/noop';

export type MovableInkCampaignContextState = {
  campaignId?: number;
  campaigns: MovableInkCampaign[];
  isFetchingCampaigns: boolean;
  hasCampaignsError: boolean;
  hasCampaigns: boolean;
  setCampaignId: (id?: number) => void;
  refetchCampaignsByTokenId: ({
    tokenId,
    companyId,
  }: Partial<{ tokenId: number; companyId: number }>) => void;
};

export const defaultState = {
  campaigns: [],
  isFetchingCampaigns: false,
  hasCampaignsError: false,
  hasCampaigns: false,
  setCampaignId: noop,
  refetchCampaignsByTokenId: noop,
};

export const MovableInkCampaignContext =
  createContext<MovableInkCampaignContextState>(defaultState);

export const useMovableInkCampaignContext = () => useContext(MovableInkCampaignContext);

export const MovableInkCampaignContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [campaignId, setCampaignId] = useState<number>();

  const {
    campaigns,
    isLoading: isFetchingCampaigns,
    refetchCampaignsByTokenId,
    isError: hasCampaignsError,
  } = useMovableInkCampaignsMutation();

  const hasCampaigns = !isFetchingCampaigns && campaigns.length > 0;

  const value = {
    campaignId,
    campaigns,
    isFetchingCampaigns,
    hasCampaignsError,
    hasCampaigns,
    setCampaignId,
    refetchCampaignsByTokenId,
  };

  return (
    <MovableInkCampaignContext.Provider value={value}>
      {children}
    </MovableInkCampaignContext.Provider>
  );
};
